import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { WishlistApi } from 'api';
import type { Wishlist } from 'api/methods/WishlistApi';

/**
 * [Wishlist] Query key 생성
 * --
 */
export const wishlistQueryKeys = createQueryKeys('wishlist', {
  getWishlist: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getWishlists: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [Wishlist] 찜/위시리스트 전체 조회
 * --
 */
export const useGetWishlists = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: wishlistQueryKeys.getWishlists(params).queryKey,
    queryFn: () => WishlistApi.getWishlists(params),
    ...options,
  });
  return data;
};

/**
 * [Wishlist] 찜/위시리스트 상세 조회
 * --
 */
export const useGetWishlist = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: wishlistQueryKeys.getWishlist(idx, params).queryKey,
    queryFn: () => WishlistApi.getWishlist(idx, params),
  });

  return data;
};

/**
 * [Wishlist] 찜/위시리스트 생성
 * --
 */
export const useCreateWishlist = (body: Wishlist) => {
  const { mutateAsync: createWishlist, ...result } = useMutation({
    mutationFn: (variables: Wishlist) => WishlistApi.createWishlist(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createWishlist, ...result };
};

/**
 * [Wishlist] 찜/위시리스트 수정
 * --
 */
export const useUpdateWishlist = (body: Wishlist) => {
  const { mutateAsync: updateWishlist, ...result } = useMutation({
    mutationFn: (variables: Wishlist) => WishlistApi.updateWishlist(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateWishlist, ...result };
};

/**
 * [Wishlist] 찜/위시리스트 삭제
 * --
 */
export const useDeleteWishlist = (idx: number) => {
  const { mutateAsync: deleteWishlist, ...result } = useMutation({
    mutationFn: (variables: number) => WishlistApi.deleteWishlist(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteWishlist, ...result };
};
